import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

const LeadSchema = z.object({
  faturamento: z.string().min(1).max(200),
  desafio: z.string().min(1).max(200),
  area: z.string().min(1).max(200),
  nome: z.string().trim().min(1).max(120),
  whatsapp: z.string().trim().min(1).max(40),
  instagram: z.string().trim().min(1).max(120),
  empresa: z.string().trim().min(1).max(120),
});

const escape = (s: string) =>
  s.replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]!));

export const sendLead = createServerFn({ method: "POST" })
  .inputValidator((data: unknown) => LeadSchema.parse(data))
  .handler(async ({ data }) => {
    const apiKey = process.env.RESEND_API_KEY;
    if (!apiKey) throw new Error("RESEND_API_KEY não configurada");

    const TO = "suporteaceleramais@outlook.com";

    const html = `
      <div style="font-family:Arial,sans-serif;max-width:600px;margin:0 auto;padding:24px;color:#111">
        <h2 style="margin:0 0 16px">Novo lead — Acelera+</h2>
        <table style="width:100%;border-collapse:collapse;font-size:14px">
          ${[
            ["Nome", data.nome],
            ["WhatsApp", data.whatsapp],
            ["Instagram", data.instagram],
            ["Empresa", data.empresa],
            ["Faturamento mensal", data.faturamento],
            ["Maior desafio", data.desafio],
            ["Área que mais trava", data.area],
          ]
            .map(
              ([k, v]) =>
                `<tr><td style="padding:8px;border:1px solid #eee;background:#fafafa;width:200px"><strong>${escape(
                  k,
                )}</strong></td><td style="padding:8px;border:1px solid #eee">${escape(v)}</td></tr>`,
            )
            .join("")}
        </table>
      </div>`;

    const res = await fetch("https://api.resend.com/emails", {
      method: "POST",
      headers: {
        Authorization: `Bearer ${apiKey}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        from: "Acelera+ Leads <onboarding@resend.dev>",
        to: [TO],
        reply_to: data.whatsapp.includes("@") ? data.whatsapp : undefined,
        subject: `Novo lead: ${data.nome} (${data.empresa})`,
        html,
      }),
    });

    if (!res.ok) {
      const errText = await res.text();
      console.error("Resend error:", res.status, errText);
      throw new Error(`Falha ao enviar email (${res.status})`);
    }

    return { success: true };
  });
